import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Input,
  InputGroup,
  Label,
  Collapse as BsCollapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { getListInvoiceType } from "store/actions";

import { InvoiceTemplateContext } from "../InvoiceTemplateContext";
import ColorPicker from "../ColorPicker";
import FileSelector from "../FileSelector";
import {
  fontSizes,
  fontFamilies,
  lineHeightOptions,
  letterSpacingOptions,
  availableCharacters,
} from "../const";

import { invoiceTable } from "../rootInvoiceTemplateConfig";

const InvoiceTemplateGeneralEditor = props => {
  const [isOpenLineHeightMenu, setIsOpenLineHeightMenu] = useState(false);
  const [isOpenLetterSpacingMenu, setIsOpenLetterSpacingMenu] = useState(false);
  const { state, dispatch } = useContext(InvoiceTemplateContext);
  const { selectedElements } = state;
  const { invoiceData } = state;

  const appDispatch = useDispatch();
  const { invoiceTableSection, invoiceSection } = invoiceData;

  const { listInvoiceType } = useSelector(state => state.invoiceTemplate);

  const [invoiceTypeOptions, setInvoiceTypeOptions] = useState([]);
  const [selectedInvoiceType, setSelectedInvoiceType] = useState(
    invoiceTypeOptions[0]
  );

  const dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = dashboard;

  useEffect(() => {
    if (finalBuInfo?.id) {
      appDispatch(getListInvoiceType(finalBuInfo.id));
    }
  }, [finalBuInfo]);

  useEffect(() => {
    if (listInvoiceType) {
      const options = listInvoiceType.map(item => ({
        value: item,
        label: item.name,
      }));

      setInvoiceTypeOptions(options);
      setSelectedInvoiceType(options[0]);
    }
  }, [listInvoiceType]);

  const updateInvoiceData = (key, value) => {
    dispatch({
      type: "updateInvoiceData",
      payload: { path: key, value },
    });
  };

  const updateStyleForSelectedElements = style => {
    dispatch({
      type: "updateStyleForSelectedElement",
      payload: { style },
    });
  };

  const handleUploadImage = event => {
    return new Promise((resolve, reject) => {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = () => {
          const base64String = reader.result
            .replace("data:", "")
            .replace(/^.+,/, "");

          const base64 = `data:image/*;base64,${base64String}`;

          resolve({
            file,
            base64,
          });
        };
        reader.readAsDataURL(file);
      } else {
        reject(null);
      }
    });
  };

  const handleUploadThumbnail = event => {
    handleUploadImage(event).then(data => {
      updateInvoiceData("rootTemplateThumbnail", data.base64);
    });
  };

  const handleChangeInvoiceType = event => {
    setSelectedInvoiceType(event);

    if (event.value) {
      updateInvoiceData(
        "invoiceSection.serialNo.prefix",
        event.value.ttchung_khhdon
      );

      let index = event.label.indexOf("(không mã");
      if (index < 0) {
        index = event.label.indexOf("(có mã");
      }
      if (index < 0) {
        index = event.label.length - 1;
      }
      const label = event.label.substring(0, index);
      updateInvoiceData("invoiceSection.fields[0].label.vi", label);
    }
  };

  useEffect(() => {
    if (selectedInvoiceType) {
      const invoiceType = selectedInvoiceType.value.ttchung_khmshdon;
      const fields = invoiceTable[invoiceType]?.fields;
      const summaryFields = invoiceTable[invoiceType]?.summaryFields;

      if (fields) {
        updateInvoiceData("invoiceTableSection.fields", fields);
      }
      if (summaryFields) {
        updateInvoiceData("invoiceTableSection.summaryFields", summaryFields);
      }
    }
  }, [selectedInvoiceType]);

  return (
    <div>
      <div className="container-fluid">
        {props.isCreateRootTemplate && (
          <div className="row border-b py-2">
            <Label className="col-3 col-form-label fw-bold">Loại hóa đơn</Label>
            <div className="col-9 d-flex align-items-center">
              <Select
                value={selectedInvoiceType}
                onChange={event => {
                  handleChangeInvoiceType(event);
                }}
                options={invoiceTypeOptions}
                placeholder="Chọn loại hóa đơn"
                className="w-100 "
                classNamePrefix="select2-selection"
              />
            </div>
          </div>
        )}

        {/* Start form number, serial number */}
        <div className="row border-b py-2">
          <Label className="col-3 col-form-label fw-bold">Ký hiệu</Label>
          <div className="col-4 d-flex align-items-center">
            <InputGroup>
              {props.isCreateRootTemplate ? (
                <input
                  type="text"
                  className="form-control"
                  value={invoiceSection.serialNo.prefix}
                  placeholder=""
                  onChange={event => {
                    updateInvoiceData(
                      "invoiceSection.serialNo.prefix",
                      event.target.value
                    );
                  }}
                />
              ) : (
                <div className="input-group-text">
                  {invoiceSection.serialNo.type}
                  {invoiceSection.serialNo.prefix}
                </div>
              )}
              <input
                type="text"
                className="form-control text-uppercase"
                value={invoiceSection.serialNo.value}
                onKeyPress={event => {
                  if (event.target.value.trim()?.length >= 2) {
                    event.preventDefault();
                  }
                  if (!availableCharacters.includes(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={event => {
                  updateInvoiceData(
                    "invoiceSection.serialNo.value",
                    event.target.value.toUpperCase()
                  );
                }}
              />
            </InputGroup>
          </div>
        </div>
        {/* End form number, serial number */}

        {/* End language */}
        <div className="row border-b py-2">
          <Label className="col-sm-3 col-form-label fw-bold">Ngôn ngữ</Label>
          <div className="col-sm-9  d-flex align-items-center">
            <div className="form-check">
              <Input
                type="checkbox"
                className="form-check-Input"
                id="bilingual-checkbox"
                checked={invoiceData.bilingualEnabled}
                onChange={() =>
                  updateInvoiceData(
                    "bilingualEnabled",
                    !invoiceData.bilingualEnabled
                  )
                }
              />
              <Label className="form-check-label" htmlFor="bilingual-checkbox">
                Song ngữ (Việt - Anh)
              </Label>
            </div>
          </div>
        </div>
        {/* End language */}

        {/* Start color style */}
        <div className="row border-b py-2">
          <Label className="col-sm-3 col-form-label fw-bold">Màu sắc</Label>
          <div className="col-sm-9 d-flex align-items-center">
            <ColorPicker
              size="21px"
              value={invoiceData.style.color}
              presetColors={[
                "rgba(0,0,0,1)",
                "rgba(2, 119, 189, 1)",
                "rgba(255, 0, 0, 1)",
                "rgba(112, 205, 221, 1)",
              ]}
              onChange={color => {
                if (selectedElements?.length > 0) {
                  updateStyleForSelectedElements({ color });
                } else {
                  updateInvoiceData("style", { color });
                }
              }}
            />
          </div>
        </div>
        {/* End color style */}

        {/* Start font style */}
        <div className="row border-b py-2">
          <Label className="col-sm-3 col-form-label fw-bold">Font chữ</Label>
          <div className="col-sm-9">
            <div className="mt-2 d-flex align-items-center">
              <select
                className="form-select flex-grow-0"
                style={{ width: "180px" }}
                value={invoiceData.style.fontFamily}
                onChange={event => {
                  if (selectedElements?.length > 0) {
                    updateStyleForSelectedElements({
                      fontFamily: event.target.value,
                    });
                  } else {
                    updateInvoiceData("style", {
                      fontFamily: event.target.value,
                    });
                  }
                }}
              >
                {fontFamilies.map((fontFamily, index) => (
                  <option key={index} value={fontFamily}>
                    {fontFamily}
                  </option>
                ))}
              </select>

              <select
                className="form-select ms-3 flex-grow-0"
                style={{ width: "80px" }}
                value={invoiceData.style.fontSize}
                onChange={event => {
                  if (selectedElements?.length > 0) {
                    updateStyleForSelectedElements({
                      fontSize: event.target.value,
                    });
                  } else {
                    updateInvoiceData("style", {
                      fontSize: event.target.value,
                    });
                  }
                }}
              >
                {fontSizes.map((fontSize, index) => (
                  <option key={index} value={fontSize.value}>
                    {fontSize.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-3 d-flex align-items-center">
              <div
                className="btn-group btn-group-toggle btn-font-style"
                data-toggle="buttons"
              >
                <input
                  type="checkbox"
                  className="btn-check"
                  id="btn-font-weight-checkbox"
                  checked={invoiceData.style.fontWeight === "bold"}
                  onChange={event => {
                    if (selectedElements?.length > 0) {
                      updateStyleForSelectedElements({
                        fontWeight: event.target.checked ? "bold" : "normal",
                      });
                    } else {
                      updateInvoiceData("style", {
                        fontWeight: event.target.checked ? "bold" : "normal",
                      });
                    }
                  }}
                />
                <label
                  className="btn btn-outline-secondary mb-0 fw-bold"
                  htmlFor="btn-font-weight-checkbox"
                >
                  <i className="bx bx-bold font-size-16" />
                </label>

                <input
                  type="checkbox"
                  className="btn-check"
                  id="btn-font-style-checkbox"
                  checked={invoiceData.style.fontStyle === "italic"}
                  onChange={event => {
                    if (selectedElements?.length > 0) {
                      updateStyleForSelectedElements({
                        fontStyle: event.target.checked ? "italic" : "normal",
                      });
                    } else {
                      updateInvoiceData("style", {
                        fontStyle: event.target.checked ? "italic" : "normal",
                      });
                    }
                  }}
                />
                <label
                  className="btn btn-outline-secondary mb-0 fst-italic"
                  htmlFor="btn-font-style-checkbox"
                >
                  <i className="bx bx-italic font-size-16" />
                </label>

                <input
                  type="checkbox"
                  className="btn-check"
                  id="btn-text-decoration-checkbox"
                  checked={invoiceData.style.textDecoration === "underline"}
                  onChange={event => {
                    if (selectedElements?.length > 0) {
                      updateStyleForSelectedElements({
                        textDecoration: event.target.checked
                          ? "underline"
                          : "none",
                      });
                    } else {
                      updateInvoiceData("style", {
                        textDecoration: event.target.checked
                          ? "underline"
                          : "none",
                      });
                    }
                  }}
                />
                <label
                  className="btn btn-outline-secondary mb-0"
                  htmlFor="btn-text-decoration-checkbox"
                >
                  <i className="bx bx-underline font-size-16" />
                </label>
              </div>

              <div className="ms-3">
                <Dropdown
                  isOpen={isOpenLineHeightMenu}
                  toggle={() => setIsOpenLineHeightMenu(!isOpenLineHeightMenu)}
                >
                  <DropdownToggle
                    caret
                    className="btn-line-height"
                  ></DropdownToggle>
                  <DropdownMenu>
                    {lineHeightOptions.map(lineHeight => (
                      <DropdownItem
                        key={lineHeight.value}
                        onClick={() => {
                          if (selectedElements?.length > 0) {
                            updateStyleForSelectedElements({
                              lineHeight: lineHeight.value,
                            });
                          } else {
                            updateInvoiceData("style", {
                              lineHeight: lineHeight.value,
                            });
                          }
                        }}
                      >
                        {lineHeight.label}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>
              <div className="ms-3">
                <Dropdown
                  isOpen={isOpenLetterSpacingMenu}
                  toggle={() =>
                    setIsOpenLetterSpacingMenu(!isOpenLetterSpacingMenu)
                  }
                >
                  <DropdownToggle
                    caret
                    className="btn-letter-spacing"
                  ></DropdownToggle>
                  <DropdownMenu>
                    {letterSpacingOptions.map(letterSpacing => (
                      <DropdownItem
                        key={letterSpacing.value}
                        onClick={() => {
                          if (selectedElements?.length > 0) {
                            updateStyleForSelectedElements({
                              letterSpacing: letterSpacing.value,
                            });
                          } else {
                            updateInvoiceData("style", {
                              letterSpacing: letterSpacing.value,
                            });
                          }
                        }}
                      >
                        {letterSpacing.label}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        {/* End font style */}

        {/* Start ordering */}
        <div className="row border-b py-3">
          <Label className="col-sm-3 col-form-label fw-bold">
            Thứ tự hiển thị
          </Label>
          <div className="col-sm-9  d-flex align-items-center">
            <select
              className="form-select"
              value={invoiceData.viewPrioritize}
              onChange={event => {
                updateInvoiceData("viewPrioritize", event.target.value);
              }}
            >
              <option value="invoiceSection">Ưu tiên thông tin hóa đơn</option>
              <option value="sellerSection">
                Ưu tiên thông tin đơn vị bán
              </option>
            </select>
          </div>
        </div>
        {/* End ordering */}

        {/* Start customer */}
        <div className="row border-b py-2">
          <Label className="col-sm-3 col-form-label fw-bold">Người mua</Label>
          <div className="col-sm-9  d-flex align-items-center">
            <div className="form-check">
              <Input
                type="checkbox"
                className="form-check-Input"
                id="customer-section-border-checkbox"
                checked={invoiceData.customerSection.border.enabled}
                onChange={event =>
                  updateInvoiceData(
                    "customerSection.border.enabled",
                    event.target.checked
                  )
                }
              />
              <Label
                className="form-check-label"
                htmlFor="customer-section-border-checkbox"
              >
                Giá trị người mua có gạch chân
              </Label>
            </div>
          </div>
        </div>
        {/* End customer */}

        {/* Start table customize */}
        <div className="row border-b py-2">
          <Label className="col-sm-3 col-form-label fw-bold">
            Tùy chỉnh bảng
          </Label>
          <div className="col-sm-9 d-flex flex-column">
            <div className="form-check mt-2">
              <Input
                type="checkbox"
                className="form-check-Input"
                id="border-enabled-checkbox"
                checked={invoiceTableSection.border.enabled}
                onChange={event =>
                  updateInvoiceData(
                    "invoiceTableSection.border.enabled",
                    event.target.checked
                  )
                }
              />
              <Label
                className="form-check-label"
                htmlFor="border-enabled-checkbox"
              >
                Bảng có dòng kẻ hàng
              </Label>
            </div>

            <BsCollapse isOpen={invoiceTableSection.border.enabled}>
              <div className="d-flex mt-3 ms-3 justify-content-start">
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectStyleForTableLine"
                    id="dashedLine"
                    checked={
                      invoiceTableSection.border.style.borderStyle === "dashed"
                    }
                    onChange={() =>
                      updateInvoiceData("invoiceTableSection.border.style", {
                        borderStyle: "dashed",
                      })
                    }
                  />
                  <label className="form-check-label mb-0" htmlFor="dashedLine">
                    <div
                      style={{
                        width: "80px",
                        height: "1px",
                        margin: "10px 8px 8px",
                        borderTop: "1px dashed #000000",
                      }}
                    ></div>
                  </label>
                </div>

                <div className="form-check mb-3 ms-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectStyleForTableLine"
                    id="solidLine"
                    checked={
                      invoiceTableSection.border.style.borderStyle === "solid"
                    }
                    onChange={() =>
                      updateInvoiceData("invoiceTableSection.border.style", {
                        borderStyle: "solid",
                      })
                    }
                  />
                  <label className="form-check-label mb-0" htmlFor="solidLine">
                    <div
                      style={{
                        width: "80px",
                        height: "1px",
                        margin: "10px 8px 8px",
                        borderTop: "1px solid #000000",
                      }}
                    ></div>
                  </label>
                </div>
              </div>
            </BsCollapse>

            <div className="form-check mt-3">
              <Input
                type="checkbox"
                className="form-check-Input"
                id="hasNumberSymbol-checkbox"
                checked={invoiceTableSection.hasNumberSymbol}
                onChange={event =>
                  updateInvoiceData(
                    "invoiceTableSection.hasNumberSymbol",
                    event.target.checked
                  )
                }
              />
              <Label
                className="form-check-label"
                htmlFor="hasNumberSymbol-checkbox"
              >
                Thiết lập số dòng ký hiệu cột
              </Label>
            </div>

            <div className="mt-3 row">
              <Label className="col-4 col-form-label">Số dòng trắng</Label>
              <div className="col-4">
                <input
                  type="number"
                  min="5"
                  max="10"
                  className="form-control"
                  value={invoiceTableSection.numberOfLines}
                  onChange={event => {
                    try {
                      let numberOfLines = parseInt(event.target.value, 10);
                      if (numberOfLines && typeof numberOfLines == "number") {
                        if (numberOfLines > 10) {
                          numberOfLines = 10;
                        }
                        if (numberOfLines < 5) {
                          numberOfLines = 5;
                        }
                      } else {
                        numberOfLines = invoiceTableSection.numberOfLines;
                      }
                      updateInvoiceData(
                        "invoiceTableSection.numberOfLines",
                        numberOfLines
                      );
                    } catch (e) {
                      updateInvoiceData(
                        "invoiceTableSection.numberOfLines",
                        invoiceTableSection.numberOfLines
                      );
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* End table customize */}

        {/* Start sign label */}
        <div className="row py-2">
          <Label className="col-sm-3 col-form-label fw-bold">Nhãn ký</Label>
          <div className="col-sm-9  d-flex align-items-center">
            <div className="form-check">
              <Input
                type="checkbox"
                className="form-check-Input"
                id="signature-boss-checkbox"
                checked={invoiceData.signatureSection.boss.enabled}
                onChange={event =>
                  updateInvoiceData(
                    "signatureSection.boss.enabled",
                    event.target.checked
                  )
                }
              />
              <Label
                className="form-check-label"
                htmlFor="signature-boss-checkbox"
              >
                Chữ ký thủ trưởng
              </Label>
            </div>
          </div>
        </div>
        {/* End sign label */}

        {(props.isCreateRootTemplate || invoiceData.isRootTemplate) && (
          <>
            <div className="row py-2">
              <Label className="col-sm-3 col-form-label fw-bold">
                Hình mẫu
              </Label>
              <div className="col-sm-9 mt-2 d-flex align-items-center">
                <div className="d-flex flex-column align-items-start">
                  <Label>Hình ảnh xem trước cho hóa đơn mẫu</Label>
                  <FileSelector onChange={handleUploadThumbnail} />
                  {invoiceData.rootTemplateThumbnail && (
                    <div className="mt-3 border border-primary border-2 card rounded p-1">
                      <div className="position-relative">
                        <button
                          className="btn-remove-image"
                          onClick={() =>
                            updateInvoiceData("rootTemplateThumbnail", "")
                          }
                        >
                          <i className="bx bx-trash" />
                        </button>
                      </div>
                      <img
                        style={{ maxWidth: "100%" }}
                        src={invoiceData.rootTemplateThumbnail}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

InvoiceTemplateGeneralEditor.propTypes = {
  isCreateRootTemplate: PropTypes.bool,
};

export default InvoiceTemplateGeneralEditor;
